<template>
  <div>
    <div class="centerx">
      <vs-popup
        class="holamundo"
        v-bind:title="'Ajuda - Cadastro de ferramentas'"
        :active.sync="popupActivo"
      >
        <div v-html="textoAjuda"></div>
      </vs-popup>
    </div>
    <div
      class="card card-header list-group-item list-group-item-action active mb-3"
    >
      <h4 class="mb-0">Cadastro de ferramentas</h4>
      <div
        class="badge bagde-default"
        @click="popupActivo = true"
        style="position: absolute; top: 17px; right: 15px"
      >
        Ajuda <i class="fa fa-question-circle"></i>
      </div>
    </div>
    <div class="card">
      <form style="padding: 15px" @submit="fnCadastra" method="post">
        <h4 class="mb-3">Dados da ferramenta</h4>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="_form-periodo">Ferramenta</label>
            <vs-select
                id="_form-periodo"
                placeholder="Selecione a ferramenta"
                class="selectExample"
                label-placeholder="Autocomplete"
                autocomplete
                v-model="cadastro.ferramentaId"
                style="width:100%"
                >
                <vs-select-item :key="index" :value="item.ferramentaId" :text="item.titulo" v-for="(item,index) in ferramentas" />
              </vs-select>    

              <div class="form-group mt-2" v-if="cadastro.ferramentaId == 0">
                <label>Outro</label>
                <input type="text" name="outraferramenta" v-model="outraferramenta" class="form-control">
              </div>  
          </div>
          <div class="form-group col-md-4">
            <label for="_form-valorAquisicao">Valor aquisição</label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.valorAquisicao"
              id="_form-valorAquisicao"
              required
              currency="R$"
              separator="."
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-valorNovo">Data da aquisição</label>
            <date-picker
              style="width: 100%"
              v-model="cadastro.dataAquisicao"
              value-type="format"
              format="DD/MM/YYYY"
            ></date-picker>
          </div>
          <div class="form-group col-md-4">
            <label for="_form-valorNovo">Valor novo</label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.valorNovo"
              id="_form-valorNovo"
              required
              currency="R$"
              separator="."
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-custoManutencao">Custo manutenção</label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.custoManutencao"
              id="_form-custoManutencao"
              required
              currency="R$"
              separator="."
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-periodo">Período</label>
               <vs-select
                id="_form-periodo"
                placeholder="Selecione o período"
                class="selectExample"
                label-placeholder="Autocomplete"
                autocomplete
                v-model="cadastro.periodoId"
                style="width:100%"
                >
                <vs-select-item :key="index" :value="item.periodoId" :text="item.titulo" v-for="(item,index) in periodos" />
              </vs-select>    

              <div class="form-group mt-2" v-if="cadastro.periodoId == 0">
                <label>Outro</label>
                <input type="text" name="outroperiodo" v-model="outroperiodo" class="form-control">
              </div>  
          </div>
          <div class="form-group col-md-4">
            <label for="_form-valorNovo">Anos vida útil</label>
            <vue-numeric
              type="text"
              class="form-control"
              v-model="cadastro.anosVidaUtil"
              id="_form-valorNovo"
              required
            />
          </div>
        </div>
        <div style="display: flex; jusify-content: flex-end">
          <button class="btn btn-primary ml-auto">Salvar</button>
        </div>
      </form>
      <div style="padding: 15px">
        <vs-table :data="content">
          <template slot="header">
            <h3>Registros</h3>
          </template>
          <template slot="thead">
            <vs-th :style="'width:' + iconArea + 'px'"> Ações </vs-th>
            <vs-th> Ferramenta </vs-th>
            <vs-th style="width: 150px"> Valor aquisição </vs-th>
            <vs-th style="width: 120px"> Valor novo </vs-th>
            <vs-th style="width: 120px"> Custo manutenção </vs-th>
            <vs-th style="width: 150px"> Perídodo </vs-th>
            <vs-th style="width: 120px"> Anos vida útil </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <a
                  class="icone-editar"
                  data-editar
                  @click="fnEditar(indextr)"
                  title="Editar"
                >
                  <i class="i-circled i-small i-light icon-line-edit"></i>
                </a>
                <a
                  class="icone-editar"
                  data-deletar
                  @click="fnDeletar(tr.etapaId)"
                  title="Deletar"
                >
                  <i class="i-circled i-small i-light icon-trash"></i>
                </a>
              </vs-td>
              <vs-td :data="tr.ferramentaId">
                {{ fnConcat(tr.ferramentaId) }}
              </vs-td>

              <vs-td :data="tr.valorAquisicao">
                R$ {{ formataPrice(tr.valorAquisicao) }}
                <div>{{ formatData(tr.dataAquisicao) }}</div>
              </vs-td>

              <vs-td :data="tr.valorNovo">
                R$ {{ formataPrice(tr.valorNovo) }}
              </vs-td>
              <vs-td :data="tr.custoManutencao">
                R$ {{ formataPrice(tr.custoManutencao) }}
              </vs-td>
              <vs-td :data="tr.periodoId">
                {{ fnConcat2(tr.periodoId) }}
              </vs-td>
              <vs-td :data="tr.valor">
                {{ tr.anosVidaUtil }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { getSuccess, formatPrice, clientKey } from "../../../global/utils";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";

export default {
  data() {
    return {
      content: [],
      cadastro: {},
      ferramentas: {},
      periodos: {},
      incluindo: false,
      iconArea: 48 * 2,
      titulo: "",
      tipo: "",
      servico: null,
      textoAjuda: null,
      popupActivo: false,
      cadastroid: null,
      outraferramenta: "",
      outroperiodo:""
    };
  },
  components: { DatePicker },

  mounted() {
    this.fnGetContratacao();
    this.fnGetferramentas();
    this.fnGetPeriodos();
  },
  methods: {
    async fnGetferramentas() {
      await this.$http
        .get("listaferramentas/api/")
        .then((res) => {
          this.ferramentas = res.data;
          this.ferramentas.push({ferramentaId:0, titulo:"Outros"})
        })
        .catch(() => {});
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY");
    },
    async fnGetPeriodos() {
      await this.$http
        .get("listaperiodos/api/")
        .then((res) => {
          this.periodos = res.data;
          this.periodos.push({periodoId:0, titulo:"Outros"})

        })
        .catch(() => {});
    },
    formataPrice(val) {
      return formatPrice(val);
    },
    async fnCadastra(e) {
      e.preventDefault();
      const metodo = this.cadastro.etapaId ? "put" : "post";
      console.log(
        this.$moment(this.cadastro.dataAquisicao, "DD/MM/AAAA").format(
          "YYYY-MM-DD"
        )
      );
      this.cadastro.dataAquisicao = this.$moment(
        this.cadastro.dataAquisicao,
        "DD/MM/AAAA"
      ).format("YYYY-MM-DD");
      this.cadastro.tsAlteracao = this.cadastro.etapaId
        ? this.$moment().format()
        : null;
      const completaUrl = this.cadastro.etapaId
        ? "/" + this.cadastro.etapaId
        : "";

        let headers = {
        'outraferramenta': this.outraferramenta,
        'outroperiodo':this.outroperiodo
      };  
      await this.$http[metodo]("/etapa_09" + completaUrl+"?outraferramenta="+this.outraferramenta+"&outroperiodo="+this.outroperiodo, this.cadastro,{headers:headers})
        .then((res) => {
          if (metodo == "post") {
            this.content.push(res.data);
          }
          getSuccess();
          this.cadastro = {
            contratacaoId: this.cadastroid,
          };
          window.location.reload(true);
        })
        .catch(() => {});
    },

    async fnGetContratacao() {
      await this.$http
        .get(`contratacao/codigo/${this.$route.params.codigoContrato}/etapa_09`)
        .then((res) => {
          this.cadastro.contratacaoId = res.data.contratacaoId;
          this.cadastroid = res.data.contratacaoId;
          if (res.data.contratacoesEVO09 != null) {
            var toString = JSON.stringify(res.data.contratacoesEVO09);
            var toJson = JSON.parse(toString);
            for (var i = 0; i < toJson.length; i++) {
              this.content.push(toJson[i]);
            }
          }
        })
        .catch(() => {});
      await this.$http
        .get(`contratacao/lista/${this.$route.params.codigoContrato}`)
        .then((res) => {
          this.servico = res.data.servicos;
          this.textoAjuda = this.servico.textoAjuda09;
        });
    },
    fnCancela() {
      this.incluindo = false;
      this.titulo = "";
      this.tipo = "";
    },
    fnEdicao(val) {
      if (val == "Incluindo") {
        this.incluindo = true;
        this.titulo = "Incluindo novo registro";
        this.tipo = "Inclusão";
      }
    },
    fnEditar(i) {
      this.cadastro = this.content[i];
      this.cadastro.dataAquisicao = this.formatData(
        this.cadastro.dataAquisicao
      );
    },
    fnConcat(val) {
      var item = this.ferramentas.filter((administracoes) => {
        return administracoes.ferramentaId == val;
      });
      var toString = JSON.stringify(item);
      var toJson = JSON.parse(toString);
      return toJson[0].titulo;
    },
    fnConcat2(val) {
      var item = this.periodos.filter((data) => {
        return data.periodoId == val;
      });
      var toString = JSON.stringify(item);
      var toJson = JSON.parse(toString);
      return toJson[0].titulo;
    },
    convertToken(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    },
    async fnDeletar(val) {
      var token = localStorage.getItem(clientKey);
      var dataToken = this.convertToken(token);
      await this.$http
        .delete(`/etapa_09/${val}/${dataToken.ClienteId}`)
        .then(() => {
          let i = this.content.map((item) => item.etapaId).indexOf(val);
          this.content.splice(i, 1);
          getSuccess();
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.card-header {
  h4 {
    color: #fff;
    text-align: center;
  }
}
.expand-user {
  width: 100%;
}
</style>